import React from 'react';
import withStyles, { StyleRules } from '@material-ui/core/styles/withStyles';
import Grid, { GridProps } from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles';

type MarginType = 'sparse' | 'dense' | 'zero';

type CustomGridItemClassKey = MarginType | 'textNoWrap';

const styles = (theme: Theme): StyleRules => ({
  zero: {
    margin: theme.spacing(0, 0),
  },
  dense: {
    margin: theme.spacing(0, 0, 2),
  },
  sparse: {
    margin: theme.spacing(0, 0, 4),
  },
  textNoWrap: {
    whiteSpace: 'nowrap',
  },
});

type CustomGridItemProps = GridProps & {
  classes: { [key in CustomGridItemClassKey]: string };
  margin?: MarginType;
  textNoWrap?: boolean;
};

const CustomGridItem = ({
  classes,
  margin = 'sparse',
  textNoWrap = false,
  xs = 12,
  ...props
}: CustomGridItemProps) => {
  return (
    <Grid
      item
      xs={xs}
      className={[classes[margin], textNoWrap && classes.textNoWrap]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />
  );
};

export default withStyles(styles)(CustomGridItem);
